import axios from 'axios'
import { API_URL } from '../../config/apiConfig';
import { combineEpics, Epic } from 'redux-observable'
import { catchError, filter, map, mergeMap, startWith, switchMap } from 'rxjs/operators'
import {
  addedToppagesaboutus,
  addingToppagesaboutus,
  addingToppagesaboutusFailed,
  editedToppagesaboutus,
  editingToppagesaboutus,
  editingToppagesaboutusFailed,
  foundToppagesaboutus,
  loadedToppagesaboutus,
  loadingToppagesaboutus,
  loadingToppagesaboutusFailed,
  removedToppageaboutus,
  removingToppageaboutus,
  removingToppageaboutusFailed,
  searchingToppagesaboutus,
  searchingToppagesaboutusFailed,
  softRemovedToppagesaboutus,
  softRemovingToppagesaboutus,
  softRemovingToppagesaboutusFailed,
  ToppagesaboutusAction,
  ToppagesaboutusActionTypes,
} from '../actions/toppagesaboutusActions'
import buildFormData from './buildFormData'

import { from, of } from 'rxjs'
import { isOfType } from 'typesafe-actions'
import { IState } from '../reducers'


const searchToppagesaboutusEpic: Epic<ToppagesaboutusAction, ToppagesaboutusAction, IState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(ToppagesaboutusActionTypes.SEARCH_TOPPAGESABOUTUS)),
    mergeMap((action) => {
      if (typeof action.searchOptions === 'string') {
        action.searchOptions = {
          searchString: action.searchOptions,
          page: 1,
          searchField: '_id',
        }
      }
      let url = `${API_URL}/api/toppagesaboutus/search/`
      return from(axios.get(url, { params: action.searchOptions })).pipe(
        map((response) => foundToppagesaboutus(response.data, action.keep)),
        startWith(searchingToppagesaboutus()),
        catchError(() => of(searchingToppagesaboutusFailed()))
      )
    })
  )

const loadToppagesaboutusEpic: Epic<ToppagesaboutusAction, ToppagesaboutusAction, IState> = (action$, state$) => {
  let responses = []
  return action$.pipe(
    filter(isOfType(ToppagesaboutusActionTypes.LOAD_TOPPAGESABOUTUS)),
    switchMap((action) => {
      let url = `${API_URL}/api/toppagesaboutus/`
      return from(axios.get(url, { params: action.loadOptions })).pipe(
        map((response) => loadedToppagesaboutus(response.data)),
        startWith(loadingToppagesaboutus()),
        catchError(() => of(loadingToppagesaboutusFailed()))
      )
    })
  )
}

const addToppagesaboutusEpic: Epic<ToppagesaboutusAction, ToppagesaboutusAction, IState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(ToppagesaboutusActionTypes.ADD_TOPPAGESABOUTUS)),

    mergeMap((action) => {
      const data = new FormData()
      buildFormData(data, action.payload)
      const config = {
        headers: {
          'content-type': 'multipart/form-data',
        },
      }

      return from(axios.post(`${API_URL}/api/toppagesaboutus/`, data, config)).pipe(
        map((response) => addedToppagesaboutus(response.data)),
        startWith(addingToppagesaboutus()),
        catchError((err) => of(addingToppagesaboutusFailed(err.response)))
      )
    })
  )

const removeToppagesaboutusEpic: Epic<ToppagesaboutusAction, ToppagesaboutusAction, IState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(ToppagesaboutusActionTypes.REMOVE_TOPPAGEABOUTUS)),
    mergeMap((action) =>
      from(axios.delete(`${API_URL}/api/toppagesaboutus/${action.payload._id}`)).pipe(
        map((response) => removedToppageaboutus()),
        startWith(removingToppageaboutus()),
        catchError(() => of(removingToppageaboutusFailed()))
      )
    )
  )

const softRemoveToppagesaboutusEpic: Epic<ToppagesaboutusAction, ToppagesaboutusAction, IState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(ToppagesaboutusActionTypes.SOFT_REMOVE_TOPPAGESABOUTUS)),
    mergeMap((action) =>
      from(axios.delete(`${API_URL}/api/toppagesaboutus/soft/${action.payload._id}`)).pipe(
        map((response) => softRemovedToppagesaboutus(response.data.record)),
        startWith(softRemovingToppagesaboutus()),
        catchError((err) => of(softRemovingToppagesaboutusFailed(err.response)))
      )
    )
  )

const editToppagesaboutusEpic: Epic<ToppagesaboutusAction, ToppagesaboutusAction, IState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(ToppagesaboutusActionTypes.EDIT_TOPPAGESABOUTUS)),
    mergeMap((action) => {
      const data = new FormData()
      buildFormData(data, action.payload)
      const config = {
        headers: {
          'content-type': 'multipart/form-data',
        },
      }

      return from(axios.put(`${API_URL}/api/toppagesaboutus/${action.payload._id}`, data, config)).pipe(
        map((response) => editedToppagesaboutus(response.data)),
        startWith(editingToppagesaboutus()),
        catchError((err) => of(editingToppagesaboutusFailed(err.response)))
      )
    })
  )

export default combineEpics(
  searchToppagesaboutusEpic,
  loadToppagesaboutusEpic,
  addToppagesaboutusEpic,
  removeToppagesaboutusEpic,
  softRemoveToppagesaboutusEpic,
  editToppagesaboutusEpic
)
